module.exports = __webpack_public_path__ + "img/icon_dash.8a75e24c.svg";